/**
 * Small seedable PRNG (mulberry32). Deterministic per seed so sketches can be
 * reproduced exactly — useful for attract-mode replays and debugging.
 */
export class PRNG {
  private state: number;

  constructor(seed = 0x9e3779b9) {
    this.state = seed >>> 0;
  }

  /** Re-seed in place. */
  seed(seed: number): void {
    this.state = seed >>> 0;
  }

  /** Uniform float in [0, 1). */
  next(): number {
    this.state |= 0;
    this.state = (this.state + 0x6d2b79f5) | 0;
    let t = Math.imul(this.state ^ (this.state >>> 15), 1 | this.state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /** Uniform float in [min, max). */
  range(min: number, max: number): number {
    return min + (max - min) * this.next();
  }

  /** Random sign, -1 or 1. */
  sign(): number {
    return this.next() < 0.5 ? -1 : 1;
  }
}
